import { createFileRoute } from '@tanstack/react-router';
import Locations from 'src/pages/Organization/Branches/Locations';

export const Route = createFileRoute(
  '/$organizationSlug/branches/$branchId/locations',
)({
  component: Locations,
});
